// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1t_eG","content":"GlobalSearch_content__1qFRU"};